import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { CalculationMethod } from "../../common/calculation-method";
import { VatReleaseReasonSource } from "../../company/vat-release-reason-source";
import { AddressDTO, DocumentBuyerDTO, DocumentClientDTO } from "../../document/dto/document-client.dto";
import { SalePatternIssueBusinessDayMode } from "../sale-pattern-issue-business-day-mode";
import { SalePatternKsefSendOption } from "../sale-pattern-ksef-send-option";
import { SalePatternSchedule, SalePatternScheduleRepetitionSkip } from "../sale-pattern-schedule";
import { SplitPaymentState } from "../split-payment-state";
import { SaleDocumentGetItemDTO, SaleDocumentUpdateItemDTO } from "./sale-document-item.dto";
import { RateNP } from "../rate-np";

export class SalePatternDocumentDTO {
	public active: boolean;
	public autoPayment: boolean;
	public bankAccountId?: number | null;
	public baseCurrencyBankAccountId?: number | null;
	@Type(() => DocumentBuyerDTO) public buyer: DocumentBuyerDTO;
	public calculationMethod: CalculationMethod;
	@Type(() => DocumentClientDTO) public client: DocumentClientDTO;
	public clientEmails: string[];
	public communityTransactionId: number;
	public currencyId: number;
	@Type(() => AddressDTO) public deliveryAddress: AddressDTO;
	public dueDateDays: number;
	public emailPatternId?: number;
	public id: number;
	public issueDay: number | null;
	public issueMonth: number | null;
	public issueInBusinessDay: boolean | null;
	public issueInBusinessDayMode: SalePatternIssueBusinessDayMode;
	@Transform(transformDTODate, { toClassOnly: true }) public issuingStartDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public issuingEndDate: Date;
	public issuer: string;
	public issuerUserId: number;
	public jpkVatDocumentGroups: string[];
	public jpkVatProductGroups: string[];
	public invoiceToReceipt?: boolean;
	public name: string;
	public note: string;
	public numberingId: number;
	public paymentMethodId?: number;
	public recipient: string;
	public sendDocumentToClient: boolean;
	public sendDocumentCopyToIssuer: boolean;
	public sendEmailToIssuer: boolean;
	public splitPayment: SplitPaymentState;
	public transactionLocation: string;
	public wstoShipmentCountryId?: number;
	public wstoConsumerCountryId?: number | null;
	public wstoAdditionalInformation: string;
	public vatReleaseReasonId?: number;
	public vatReleaseReasonCustomName: string;
	public vatReleaseReasonSource: VatReleaseReasonSource;
	public version: string;
    public ksefSendOption: SalePatternKsefSendOption;
	@Transform(({ value, obj }) => value ?? (obj as { rateNp?: RateNP | null }).rateNp ?? null, { toClassOnly: true }) public rateNP: RateNP | null;
	public reverseCharge: boolean | null;
}

export class SalePatternGetDocumentDTO extends SalePatternDocumentDTO {
	@Type(() => SaleDocumentGetItemDTO) public items: SaleDocumentGetItemDTO[];
	public documentTemplateSchedule: SalePatternSchedule;
	public repetitionSkip?: SalePatternScheduleRepetitionSkip;
	public grossValue: number;
	public issuedByVatPayer: boolean;
}

export class SalePatternUpdateDocumentDTO extends SalePatternDocumentDTO {
	@Type(() => SaleDocumentGetItemDTO) public items: SaleDocumentUpdateItemDTO[];
	public schedule: SalePatternSchedule;
	public repetitionSkip?: SalePatternScheduleRepetitionSkip | null;
}
